





























































































































































































import axios from "axios"
import {Component, Prop, Vue} from 'vue-property-decorator';
import DropDown from "./Dropdown.vue";

const TextHighlight = require('vue-text-highlight').default;

Vue.component('text-highlight', TextHighlight);
Vue.use(TextHighlight);


@Component({
  components: {
    DropDown
  }
})
export default class JobListing extends Vue {

  @Prop() private msg!: string;
  JobPostings: any = [];
  jobs: any = [];
  posts: any;
  postings: any = [];
  JobId: any = this.JobPostings.id;
  isLoading: boolean = true;
  icon: any = [];
  count: any = 0;
  location: any = this.getQueryString('location', window.location.href)
  department: any = this.getQueryString('department', window.location.href)
  search: any = this.getQueryString('search', window.location.href)
  country: any = this.getQueryString('country', window.location.href)
  load: Boolean = false;
  queries: Array<any> = [];
  grid: boolean = true;


  // async mounted() {
  //     // this.location = this.location ? this.location.containsEncodedComponents: "null"
  //
  //     let urlParams = new URLSearchParams(window.location.search);
  //     let myParam = urlParams.get('department')
  //      console.log(myParam,'test98')
  //
  //     this.location = this.location ? decodeURIComponent(this.location): "null"
  //     this.department = this.department ? decodeURIComponent(this.department): "null"
  //     // this.location = this.location ? this.location.replace("%2C+", ", ").replace("+-+", " - ") : "null"
  //     // this.department = this.department ? this.department.replace("%2F", "/").replace("%26", "&").replace("%20", " ").replace("+", " ").replace("+%26+"," & ").replace("+%2F+"," / ") : "null"
  //     console.log(this.department,'depar')
  //    this.location ==='Remote'?await this.listRemoteJobs():await this.listJobs()
  // }

  async mounted() {
    // this.location = this.location ? this.location.containsEncodedComponents: "null"
    let url = new URLSearchParams(window.location.search);
    this.location = this.location ? url.get('location') : "null"
    this.department = this.department ? url.get('department') : "null"
    this.search = this.search ? url.get('search') : null
    this.country = this.country ? url.get('country') : null
    // this.location = this.location ? this.location.replace("%2C+", ", ").replace("+-+", " - ") : "null"
    // this.department = this.department ? this.department.replace("%2F", "/").replace("%26", "&").replace("%20", " ").replace("+", " ").replace("+%26+"," & ").replace("+%2F+"," / ") : "null"
    // this.location === 'Remote' ? await this.listRemoteJobs() : await this.listJobs()
    await this.listJobs()
  }


  sendToLever(applyLink: any) {
    location.href = `/opening-description/${applyLink}`;
  }

  toggle(status: string) {

    this.grid = status === 'grid'
  }


  getQueryString(field: any, url: any) {
    let href = url ? url : window.location.href;
    let reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    let string = reg.exec(href);
    return string ? string[1] : null;
  }


  // filteredJobs(data: any) {
  //     this.JobPostings = data
  //     this.isLoading = false;
  // }


  loadMore() {

    let post = this.search ? this.jobs.filter((x: any) => JSON.stringify(x).includes(this.search)) : this.jobs

    let posts = post.splice(12, 12)
    if (posts) {
      if (posts.length < 12) this.load = false;
      this.JobPostings = [...this.JobPostings, ...posts]
    }
  }



  async listJobs() {

    await axios.get(`https://api.lever.co/v0/postings/rackspace`)
        .then(((jobRes) => {
          this.JobPostings = jobRes.data;
          if(this.country!==null) {
            this.JobPostings = this.JobPostings.filter((job: any) => job.country === this.country)
          }
          else {
            if (this.location == 'null' && this.department == 'null') this.JobPostings = this.JobPostings;
            else this.JobPostings = (this.location !== 'null' && this.department !== 'null') ? this.JobPostings.filter((job: any) => job.categories.location === this.location && job.categories.department === this.department) : '' || (this.department !== '' && this.location === 'null') ? this.JobPostings.filter((job: any) => job.categories.department === this.department) : '' || (this.location !== '' && this.department === 'null') ? this.JobPostings.filter((job: any) => job.categories.location === this.location) : '';
          }
          this.isLoading = false;

        }))
    this.jobs = this.JobPostings
    this.postings = this.JobPostings

    if (this.search) {
      this.queries = [this.search];
      this.postings = this.postings.filter((x: any) => JSON.stringify(x).toLowerCase().includes(this.search))
    }

    if (this.postings.length > 12) {
      this.load = true
      this.JobPostings = this.postings.slice(0, 12)
    } else this.JobPostings = this.postings
    this.isLoading = false;
  }
}

